<nav class="sidebar__nav">
  <app-nav-list [isCollapsed]="isCollapsed"></app-nav-list>
  <app-logout [isCollapsed]="isCollapsed"></app-logout>
</nav>
<button class="sidebar__collapse" (click)="setCollapsedState()">
  <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
</button>
